import {
  Avatar,
  Box,
  Spinner,
  Text,
  useDisclosure,
  Tooltip,
} from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState, useCallback } from 'react';
import {
  FaArrowLeft,
  FaBookmark,
  FaCaretLeft,
  FaComment,
  FaHeart,
  FaRegBookmark,
  FaRegComment,
  FaRegHeart,
  FaShareAlt,
  FaFlag,
  FaDotCircle,
} from 'react-icons/fa';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../helpers/constant';
import { mutateFunction } from '../../libs/apis';
import client from '../../libs/client';
import Header from '../header/Header';
import CreateCommentModal from '../modal/CreateCommentModal';
import ShareContentModal from '../modal/ShareContentModal';
import { CustomToast } from '../toast/CustomToast';
import Comment from './Comment';
import CreateComment from './CreateComment';
import CreateReply from './CreateReply';
import FriendRequests from './FriendRequests';
import MediaDisplay from './MediaDisplay';
import Trends from './Trends';
import { useSelector } from 'react-redux';
import ReportPostModal from '../modal/ReportPostModal';
import ReactionDisplay from './ReactonDisplay';
import useData from '../../data/useData';
import ReactionUsers from './ReactionUsersModal';

const PostDetails = ({}) => {
  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isOpen: createCommentModalIsOpen,
    onClose: onCloseCreateCommentModal,
    onOpen: onOpenCreateCommentModal,
  } = useDisclosure();

  const [isNestedComment, setIsNestedComment] = useState(false);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [parentComment, setParentComment] = useState(null);
  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');

  const [reactionUsers, setReactionUsers] = useState([]);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const [latestReactionUser, setLatestReactionUser] = useState();

  const queryParams = new URLSearchParams(location.search);
  const postId = queryParams.get('id');

  const {
    data: reactionUsersData,
    isLoading: reactionUsersLoading,
    refetch: refetchReactionUsers,
  } = useData(`react/post/users?post_id=${postId}`, 30000, {}, 1, false);

  useEffect(() => {
    if (reactionUsersData) {
      setReactionUsers(reactionUsersData?.data?.reactionUsers);
    }
  }, [reactionUsersData]);

  const {
    isOpen: createShareContentIsOpen,
    onClose: onCloseShareContent,
    onOpen: onOpenShareContent,
  } = useDisclosure();

  const {
    isOpen: reportPostIsOpen,
    onClose: onCloseReportPost,
    onOpen: onOpenReportPost,
  } = useDisclosure();

  const {
    isOpen: reactionUsersIsOpen,
    onClose: onCloseReactionUsers,
    onOpen: onOpenReactionUsers,
  } = useDisclosure();

  const {
    data: postData,
    isLoading: postLoading,
    refetch: refetchPost,
  } = useData(`post/${postId}`, 30000, {}, 1, false);

  useEffect(() => {
    if (postData) {
      const data = postData.data.post;
      setPost(data);
      setIsLiked(data.isLiked);
      setLikesCount(data.likes_count);

      setLatestReactionUser(data.latestReactionUser);
      setCommentsCount(data.comment_count);
      const _message = `Hi! ${data.user.first_name} ${data.user.last_name} shared their thoughts on SeedAFounder`;
      const _link = `${process.env.REACT_APP_FRONTEND_URL}public/post?id=${postId}`;
      setMessage(_message);
      setLink(_link);
    }
  }, [postData]);

  const getComments = ({ postId, commentId, loadingState = true }) => {
    setIsLoadingComments(loadingState);
    return client()
      .get(
        commentId
          ? `${BASE_URL}comment/reply/${commentId}`
          : `${BASE_URL}comment/post/${postId}`,
      )
      .then((res) => {
        setIsLoadingComments(false);
        const data = res.data.data.comments;
        setComments(data);
      });
  };

  const getParentComment = ({ commentId }) => {
    setIsLoadingComments(true);
    return client()
      .get(`${BASE_URL}comment/${commentId}`)
      .then((res) => {
        setIsLoadingComments(false);
        const data = res.data.data.comment;
        setParentComment(data);
      });
  };

  const likePost = () => {
    try {
      mutate(
        {
          key: 'react/post',
          method: 'post',
          data: {
            post_id: post.id,
            comment_id: null,
          },
        },
        {
          onSuccess(res) {
            // addToast(res);
            refetchPost();
            // isLiked
            //   ? setLikesCount((prev) => prev - 1)
            //   : setLikesCount((prev) => prev + 1);
            // setIsLiked((prev) => !prev);
          },
          onError(e) {
            // addToast({message: 'Post was not liked'}, "error")
            console.error(e);
          },
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPostAndCommentData = useCallback(
    (isLoading = true) => {
      const params = {};
      location.search
        .replace('?', '')
        .split('&')
        .forEach((x) => {
          let arr = x.split('=');
          params[arr[0]] = arr[1];
        });
      if (params['id']) {
        refetchPost();
        getComments({
          postId: params['id'],
          commentId: params['commentId'] || null,
          loadingState: isLoading,
        });
      }
      if (params['commentId']) {
        setIsNestedComment(true);
        getParentComment({
          commentId: params['commentId'] || null,
        });
      } else {
        setIsNestedComment(false);
        setParentComment(null);
      }
    },
    [location],
  );

  useEffect(() => {
    fetchPostAndCommentData();
  }, [location]);

  const onCreateComment = (comment) => {
    // if (parentComment) {
    //   setParentComment((prev) => ({
    //     ...prev,
    //     replies_count: prev.replies_count + 1,
    //   }));
    // } else {
    //   setCommentsCount((prev) => prev + 1);
    // }
    // setComments((prev) => [comment, ...prev]);

    fetchPostAndCommentData(false);
  };

  const onCreateReply = (comment) => {
    setComments((prev) => [comment, ...prev]);
  };

  const goBack = (e) => {
    e.stopPropagation();
    navigate(-1);
  };

  const viewProfileDetails = () => {
    if (post?.user_id === userInfo?.id) {
      navigate('../account-settings');
    } else {
      const userType = post?.user?.user_type_id;
      const userId = post?.user_id;
      navigate(`../view-user?userid=${userId}&usertype=${userType}`);
    }
  };

  return (
    <Box className="">
      <Header title={'feed'} />
      <CreateCommentModal
        isOpen={createCommentModalIsOpen}
        onClose={onCloseCreateCommentModal}
        post={post}
        onSuccess={onCreateComment}
      />
      <ShareContentModal
        isOpen={createShareContentIsOpen}
        onClose={onCloseShareContent}
        message={message}
        link={link}
        subject={'Hello! Check out this post on SeedAFounder.'}
      />

      <ReportPostModal
        isOpen={reportPostIsOpen}
        onClose={onCloseReportPost}
        post={post}
      />

      <ReactionUsers
        reactionUsers={reactionUsers}
        isVisible={reactionUsersIsOpen}
        onClose={onCloseReactionUsers}
        isLoading={reactionUsersLoading}
      />

      <Box className="flex flex-col h-full bg-gray-100 gap-2 w-full">
        <Box className="px-3 py-2">
          <Box
            onClick={goBack}
            className="flex items-center cursor-pointer gap-1"
          >
            <FaArrowLeft />
            <Text>Back</Text>
          </Box>
        </Box>
        {postLoading ? (
          <Box>
            <Spinner />
          </Box>
        ) : !post ? (
          <Box>
            <Text className="text-center text-gray-700 font-bold text-sm">
              Could not load post
            </Text>
          </Box>
        ) : (
          <Box className="flex items-start justify-center w-full h-full bg-gray-100">
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto min-h-[89vh] md:px-5 pb-20 w-[90%] pt-4 max-w-3xl`}
            >
              <Box className="p-2 flex flex-col relative bg-white mb-5 rounded-lg w-full max-w-2xl mx-auto">
                {parentComment ? (
                  <Box className="h-[60%] w-[2px] bg-gray-300 absolute left-10 top-7" />
                ) : null}
                <Box className="p-2 flex mb-5">
                  <Box className="w-full cursor-pointer flex flex-col">
                    <Box className="flex items-start gap-4">
                      <Box className="cursor-pointer">
                        <Avatar
                          onClick={viewProfileDetails}
                          src={post.user.profile_image ?? null}
                          name={`${post.user.first_name} ${post.user.last_name}`}
                          size={'md'}
                        />
                      </Box>
                      <Box className="flex flex-col mb-3">
                        <Box className="flex flex-row items-center gap-1">
                          <Text
                            as="span"
                            className="font-semibold capitalize"
                            _hover={{
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              color: 'blue.600',
                            }}
                            onClick={viewProfileDetails}
                          >
                            {post.user.first_name} {post.user.last_name}
                          </Text>
                        </Box>
                        <Box className="flex items-center gap-2">

                        <Text className="text-xs text-gray-600">
                          {moment(post.createdAt).fromNow()}
                        </Text>

                          <FaDotCircle className="text-[7px]" />
                          <Text
                            as="span"
                            className="font-semibold text-xs text-gray-600 capitalize"
                          >
                            {post.user.user_type_id == 1
                              ? 'Founder'
                              : post.user.user_type_id == 2
                                ? 'Investor'
                                : post.user.user_type_id == 3
                                  ? 'Expert'
                                  : 'Member'}
                          </Text>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={`${parentComment ? 'ml-14' : ''}`}>
                      <Box className="mt-5 w-full pb-5 min-h-10">
                        <Text className="w-full" color="#000">
                          {post?.text.split('\n\n').map((text) => (
                            <span>
                              {text}
                              <br />
                            </span>
                          ))}
                        </Text>
                      </Box>
                      {post.media.length > 0 ? (
                        <MediaDisplay media={post.media} />
                      ) : null}

                      <ReactionDisplay
                        latestReactionUser={latestReactionUser}
                        likesCount={likesCount}
                        onClickReactionUsers={() => {
                          refetchReactionUsers();
                          onOpenReactionUsers();
                        }}
                      />
                      <Box className="flex items-center text-sm pb-2 px-4 justify-between">
          <Box
            className="flex gap-1 cursor-pointer items-center"
          >
            <Box className="text-xs">
              👍
            </Box>
            <Text className="text-gray-700">{likesCount}</Text>
          </Box>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              // if(createCommentModalIsOpen){
              //   onCloseCreateCommentModal();
              // }else{
              //   onOpenCreateCommentModal();
              // }
            }}
            className="flex gap-1 hover:underline cursor-pointer items-center"
          >
            <Text className="text-gray-700">{commentsCount} {commentsCount == 1 ? 'Comment' : 'Comments'}</Text>
          </Box>
        </Box>
        <Box className="flex items-center border-t border-b p-3 px-4 border-gray-200 justify-around">
          <Box
            onClick={(e) => {
              e.stopPropagation();
              likePost();
            }}
            className="flex gap-2 cursor-pointer items-center"
          >
            <Box className="text-xl">
              👍
            </Box>
            <Text className="text-gray-700 hidden md:block">Like</Text>
          </Box>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              // if(createCommentModalIsOpen){
              //   onCloseCreateCommentModal();
              // }else{
              //   onOpenCreateCommentModal();
              // }
            }}
            className="flex gap-2 cursor-pointer items-center"
          >
            <FaRegComment className="text-gray-600" />
            <Text className="text-gray-700 hidden md:block">Comment</Text>
          </Box>

          <Tooltip
            label="Share post"
            placement="top"
            hasArrow
            bg="gray.700"
            color="white"
            fontSize="sm"
          >
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onOpenShareContent();
              }}
              className="flex gap-2 cursor-pointer items-center"
            >
              <FaShareAlt />
            <Text className="text-gray-700 hidden md:block">Share</Text>

            </Box>
          </Tooltip>

          {post?.user_id !== userInfo?.id && (
            <Tooltip
              label="Report post"
              placement="top"
              hasArrow
              bg="gray.700"
              color="white"
              fontSize="sm"
            >
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenReportPost();
                }}
                className="flex gap-2 cursor-pointer items-center"
              >
                <FaFlag className="text-gray-600" />
            <Text className="text-gray-700 hidden md:block">Report</Text>

              </Box>
            </Tooltip>
          )}
        </Box>

                      {/* <Box className="flex items-center justify-between">
                        <Box className="flex gap-1 cursor-pointer items-center">
                          <FaRegComment className="text-gray-600" />
                          <Text>{commentsCount}</Text>
                        </Box>
                        <Box className="flex gap-1 cursor-pointer items-center">
                          {isLiked ? (
                            <FaHeart
                              onClick={(e) => {
                                e.stopPropagation();
                                likePost();
                              }}
                              className="text-red-600"
                            />
                          ) : (
                            <FaRegHeart
                              onClick={(e) => {
                                e.stopPropagation();
                                likePost();
                              }}
                              className="text-gray-600"
                            />
                          )}
                          <Text>{likesCount}</Text>
                        </Box>

                        <Tooltip
                          label="Share post"
                          placement="top"
                          hasArrow
                          bg="gray.700"
                          color="white"
                          fontSize="sm"
                        >
                          <Box
                            onClick={(e) => {
                              e.stopPropagation();
                              onOpenShareContent();
                            }}
                            className="flex gap-1 cursor-pointer items-center"
                          >
                            <FaShareAlt />
                          </Box>
                        </Tooltip>

                        {post?.user_id !== userInfo?.id && (
                          <Tooltip
                            label="Report post"
                            placement="top"
                            hasArrow
                            bg="gray.700"
                            color="white"
                            fontSize="sm"
                          >
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                onOpenReportPost();
                              }}
                              className="flex gap-1 cursor-pointer items-center"
                            >
                              <FaFlag className="text-gray-600" />
                            </Box>
                          </Tooltip>
                        )}
                      </Box> */}
                    </Box>
                  </Box>
                </Box>
                {parentComment ? (
                  <Comment
                    onCreateReply={onCreateReply}
                    parentId={post.id}
                    post={parentComment}
                  />
                ) : null}
              </Box>

              <Box className="p-2 bg-white rounded-lg my-5 max-w-2xl mx-auto">
                {parentComment ? (
                  <CreateReply
                    comment={parentComment}
                    postId={post.id}
                    showCloseButton={false}
                    onSuccess={onCreateComment}
                    showPost={false}
                  />
                ) : (
                  <CreateComment
                    post={post}
                    showPost={false}
                    showCloseButton={false}
                    onSuccess={onCreateComment}
                  />
                )}
              </Box>
              {postLoading || isLoadingComments ? (
                <Box>
                  <Spinner />
                </Box>
              ) : (
                <Box className="flex flex-col max-w-2xl mx-auto my-10 gap-5">
                  {comments.length > 0 ? (
                    comments.map((comment) => {
                      return (
                        <Box
                          className="p-2 bg-white rounded-lg"
                          key={comment.id}
                        >
                          <Comment
                            parentId={post.id}
                            post={comment}
                            onCommentSuccess={() =>
                              fetchPostAndCommentData(false)
                            }
                          />
                        </Box>
                      );
                    })
                  ) : (
                    <Box>
                      <Text className="font-medium text-gray-500 text-center">
                        No comments yet
                      </Text>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto w-full px-5 max-w-sm hidden lg:flex`}
            >
              <Box className="flex flex-col gap-8 py-4 w-full">
                <FriendRequests />
                <Trends />
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PostDetails;
